<p>metrics works!</p>
<div>
  <p-chart type="bar" width="400" height="400" [data]="data" ></p-chart>

</div>
